import { categoryIcon } from "@/api/utils";
import { TaskProps } from "@/interfaces/tasks_types";
import { HistoryCardBase, formatDate, formatDateTime } from "./Utils/CardHelper";

export function HistoryTaskCard({ task }: { task: TaskProps; }) {
    return (
        <HistoryCardBase key={task.task_id}>
            <div className="flex justify-between">
                <div className="flex flex-row items-center">
                    {categoryIcon(task.category) && <img src={categoryIcon(task.category) ?? ''} alt="Task Icon" className="w-5 h-5 mr-2" />}
                    <h3>Task:<span className="font-bold"> {task.title}</span> </h3>
                </div>
                <h4>Project:<span className="font-bold"> {task.project}</span></h4>
            </div>
            <div className="flex justify-between">
                <p>Assigned to:<span className="font-bold"> {task.assigned_to}</span></p>
                <p>Created on:<span className="font-bold"> {formatDate(task.date_created ?? '')}</span></p>
                {task.status === "Closed" ? <p className="text-green-700">Completed on: {formatDateTime(task.completed_at ?? '')}</p> 
                    : <p className="text-red-700">Not Completed</p>}
            </div>
        </HistoryCardBase>
    );
}
